import { render, staticRenderFns } from "./CalabozoTable.vue?vue&type=template&id=7e483be4&scoped=true"
import script from "./CalabozoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CalabozoTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalabozoTable.vue?vue&type=style&index=0&id=7e483be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e483be4",
  null
  
)

export default component.exports